<template>
  <div class="crt-overlay" aria-hidden="true">
    <div class="crt-layer crt-grille" />
    <div class="crt-layer crt-scanlines" />
    <div class="crt-layer crt-band" />
    <div class="crt-layer crt-flicker" />
    <div class="crt-layer crt-vignette" />
    <div class="crt-layer crt-glass" />
    <div
      class="crt-layer crt-tearbar"
      :style="{ top: `${crtTearY}%`, opacity: crtTearing ? 1 : 0 }"
    />
    <svg width="0" height="0" style="position: absolute" aria-hidden="true">
      <defs>
        <filter id="crt-rgb-split" x="-5%" y="-5%" width="110%" height="110%">
          <feOffset in="SourceGraphic" dx="4" dy="0" result="offR" />
          <feColorMatrix
            in="offR"
            type="matrix"
            values="1 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0"
            result="r"
          />
          <feOffset in="SourceGraphic" dx="-4" dy="0" result="offB" />
          <feColorMatrix
            in="offB"
            type="matrix"
            values="0 0 0 0 0  0 0 0 0 0  0 0 1 0 0  0 0 0 1 0"
            result="b"
          />
          <feBlend in="SourceGraphic" in2="r" mode="screen" result="rb" />
          <feBlend in="rb" in2="b" mode="screen" />
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import {
  crtTearY,
  crtTearing,
  startCrtTearLoop,
} from '../composables/useCrtTear'

let stop: (() => void) | null = null

onMounted(() => {
  stop = startCrtTearLoop()
})

onBeforeUnmount(() => {
  stop?.()
  stop = null
})
</script>
